const TERM_OF_USE_URL = 'https://www.withless.com/terms';
const PRIVACY_POLICY_URL = 'https://www.withless.com/privacy-policy';
const COOKIE_POLICY_URL = 'https://www.withless.com/cookie-policy';

const TRZ_TERMS = {
  'FR': 'https://www.treezor.com/fr/cgu-conditions-generale-dutilisation/',
  'IT': 'https://www.treezor.com/it/termini-e-condizioni-generali-di-utilizzo/',
  'default': 'https://www.treezor.com/general-terms-conditions-of-use/'
}

const WITHLESS_MOBILE_APP_URL = {
  APPLE_STORE: 'https://apps.apple.com/us/app/withless/id6618149015',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.withless.mobile'
}

export {
  COOKIE_POLICY_URL,
  WITHLESS_MOBILE_APP_URL,
  PRIVACY_POLICY_URL,
  TERM_OF_USE_URL,
  TRZ_TERMS,
};
